import React from 'react';
import '../App.css'; // Correct relative path

const Footer = () => (
    <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Powered by	EduSmartUp. Indian Developers Group - Empowering the next generation of developers.</p>
    </footer>
);

export default Footer;
